export interface ApiError {
  message: string;
  status?: number;
}

export const UNKNOWN_ERROR: ApiError = { message: "Error desconocido" };

// Normaliza cualquier error (AxiosError, ZodError, Error) a un payload
// serializable para rejectWithValue. La API responde { message } (handlers
// custom) o { detail } (HTTPException, string o lista de errores 422).
export const toApiError = (error: any): ApiError => {
  const data = error?.response?.data;
  const detail = data?.detail;
  let message: string | undefined;

  if (typeof data === "string" && !data.trimStart().startsWith("<")) {
    message = data;
  } else if (typeof data?.message === "string") {
    message = data.message;
  } else if (typeof detail === "string") {
    message = detail;
  } else if (Array.isArray(detail)) {
    message = detail.map((d: any) => d?.msg ?? String(d)).join(", ");
  }

  return {
    message: message || error?.message || UNKNOWN_ERROR.message,
    status: error?.response?.status ?? error?.status,
  };
};
